import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-release-notes-dialog',
  templateUrl: './release-notes-dialog.component.html',
  styleUrls: ['./release-notes-dialog.component.scss']
})
export class ReleaseNotesDialogComponent extends AbstractDialogContent implements OnInit {

  public className = 'ReleaseNotesDialogComponent';

  public version: string
  public displayVersion: string
  public isHidden: boolean = true

  constructor(
    public activeModal: NgbActiveModal,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.version = localStorage.getItem('appVersion')
    this.displayVersion = this.toMajorMinorVersion(this.version)
    this.isHidden = localStorage.getItem('hideReleaseNotes') === 'true'
    
    setTimeout(() => {document.getElementById('release-notes-close').focus()}, 100)
  }

  toggleHidden() {
    this.isHidden = !this.isHidden
    localStorage.setItem('hideReleaseNotes', this.isHidden.toString())
  }

  private toMajorMinorVersion(version: string): string {
    if (!version) {
      return '0.0'
    }

    const parts = version.split('.')
    if (parts.length < 2) {
      return `${parts[0] || '0'}.0`
    }

    return `${parts[0]}.${parts[1]}`
  }
}
